module.exports = __webpack_public_path__ + "static/media/2 Train-Lateral_Z1.0ed517a5.png";